"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Polling = void 0;
const baseAsyncXhr_1 = require("../baseAsyncXhr");
const DEFAULT_MAX_ATTEMPTS = 999999;
const DEFAULT_INTERVAL = 5000;
class Polling extends baseAsyncXhr_1.BaseAsyncXhr {
    constructor(eventsManager, getDataFn, interval = DEFAULT_INTERVAL, maxAttempts = DEFAULT_MAX_ATTEMPTS, sendDataFn) {
        super(eventsManager);
        this.getDataFn = getDataFn;
        this.interval = interval;
        this.maxAttempts = maxAttempts;
        this.sendDataFn = sendDataFn;
    }
    doConnect() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.startUpdate();
                return Promise.resolve();
            }
            catch (_a) {
                return Promise.reject();
            }
        });
    }
    startUpdate() {
        let currentAttempts = 0;
        this.taskId = setInterval(() => {
            this.getData(currentAttempts);
            currentAttempts++;
        }, this.interval);
    }
    getData(currentAttempts) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (currentAttempts < this.maxAttempts) {
                    const response = yield this.getDataFn();
                    this.eventsManager.notifyDataReceive(response.data);
                }
                else {
                    throw new Error('Maximum number of attempts exceeded');
                }
            }
            catch (e) {
                this.eventsManager.notifyConnectionError();
                yield this.doDisconnect();
            }
        });
    }
    doDisconnect() {
        return new Promise(resolve => {
            clearInterval(this.taskId);
            this.taskId = null;
            this.eventsManager.notifyDisconnect();
            resolve();
        });
    }
    sendData(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.sendDataFn) {
                    const response = yield this.sendDataFn(data);
                    this.eventsManager.notifyDataReceive(response.data);
                }
            }
            catch (e) {
                this.eventsManager.notifyConnectionError();
                yield this.doDisconnect();
            }
        });
    }
}
exports.Polling = Polling;
//# sourceMappingURL=index.js.map